import React, { useState, useEffect } from 'react';
import qs from 'qs';
import { Form, Input, Button, Typography, Checkbox, Alert, Spin, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import authService from 'services/auth.services';

const passwordRules = [
  { required: true, message: 'Zorunlu Alan' },
  { min: 7, message: 'Şifre en az 7 karakter olmalı.' },
  {
  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{7,}$/,
  message: 'Şifre en az bir büyük harf, bir rakam ve bir özel karakter içermelidir.',
  },
];

const RegisterConfirm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(true);
  const [showMailInput, setShowMailInput] = useState(false);
  const [useCurrentMail, setUseCurrentMail] = useState(false);
  const [isHashValid, setIsHashValid] = useState(true);
  const [isMailStatus, setIsMailStatus] = useState(true);
  const [hash, setHash] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyHash = async () => {
      try {
        const { search } = location;
        const { value } = qs.parse(search.slice(1));
        const mailStatusResponse = await authService.mailStatus({ hash: value });
        if (mailStatusResponse) {
          try {
            await authService.verifyHash({ hash: value });
            setIsHashValid(true);
            setIsVerifying(false);
            setHash(value);
            setIsMailStatus(true);
          } catch {
            setIsHashValid(false);
            setIsVerifying(false);
            setIsMailStatus(false);
          }
        } else {
          setIsVerifying(false);
          setIsMailStatus(false);
        }
      } catch {
        setIsHashValid(false);
        setIsVerifying(false);
      }
    };

    verifyHash();
  }, [location]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setIsLoading(true);
      const params = { ...values, hash };
      await authService.setPassword(params);
      setIsLoading(false);
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Hesabınız aktifleştikten sonra giriş yapabilirsiniz.',
      });
      navigate('/login');
    } catch (err) {
      setIsLoading(false);
      setError(err.message || 'Bir hata oluştu.');
      notification.error({
        message: 'İşlem Başarısız',
        description: err.message || 'Bir hata oluştu.',
      });
    }
  };

  const content = () => {
    if (!isHashValid) {
      return (
        <Form.Item>
          <Alert
            message={
              <span>
                İstek geçerlilik süresi doldu.{' '}
                <NavLink to="/register">Lütfen tekrar kayıt yapınız.</NavLink>
              </span>
            }
            type="error"
            showIcon
          />
        </Form.Item>
      );
    }

    if (!isMailStatus) {
      return (
        <Form.Item>
          <Alert
            message={
              <span>
                Link daha önce kullanılmıştır.{' '}
                <NavLink to="/register">Lütfen tekrar kayıt yapınız.</NavLink>
              </span>
            }
            type="error"
            showIcon
          />
        </Form.Item>
      );
    }

    return (
      <>
        <Form.Item>
          <Alert
            message="Şifre en az 7 karakter, bir büyük harf, bir rakam ve bir özel karakter (!@#$%^&* vb.) içermelidir."
            type="info"
            showIcon
          />
        </Form.Item>
        <Form.Item name="password" label="Şifre" rules={passwordRules}>
          <Input className="input__default" placeholder="Şifre" type="password" />
        </Form.Item>
        <Form.Item>
          <Checkbox checked={showMailInput} onChange={() => setShowMailInput(!showMailInput)}>
            Faturaların dijital olarak alınmasını istiyorum.
          </Checkbox>
        </Form.Item>
        {showMailInput && (
          <>
            <Form.Item>
              <Checkbox
                checked={useCurrentMail}
                onChange={() => setUseCurrentMail(!useCurrentMail)}
              >
                Kayıtlı mail adresimi kullan.
              </Checkbox>
            </Form.Item>
            {!useCurrentMail && (
              <Form.Item
                name="invoiceMailAddress"
                label="E-Posta"
                rules={[{ type: 'email', message: 'Geçersiz mail adresi!' }]}
              >
                <Input className="input__default" placeholder="E-Posta" />
              </Form.Item>
            )}
          </>
        )}
        <Form.Item className="float-right">
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={isLoading}
            loading={isLoading}
          >
            GÖNDER
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
    <div className="register-page flex-row align-items-center">
      <div className="register-card">
        <div className="register-form-wrapper">
          {isVerifying ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
          ) : (
            <Form form={form} onFinish={handleSubmit} layout="vertical">
              <Typography.Title level={4} className="register-title">
                Paye Kart Üye Doğrulama
              </Typography.Title>
              {error && (
                <Form.Item>
                  <Alert message="Hata" type="error" showIcon />
                </Form.Item>
              )}
              {content()}
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterConfirm;
